import { createContext } from 'react';

export const HeaderInfoContext = createContext({});
